/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, Label, Button, InputSelect, InputCheckbox, CustomLoading, Modal, Breadcrumb, SaveIcon, CustonModal, Calendar } from "../../../Components";

/* 🔗 SERVICE */
import { EquipamentServices } from "../../../Services/equipamentosServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoationtypes, changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Atualizar, Excluir, Refazer, Desfazer } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer, ContainerMap, MapButtons, MapOptions,
    RowContainer, AreasOptions, AreasTitle, AreaSrcoll, BtnIcon, CalendarContainer, ModalText } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";


const ViewEquipaments = () => {
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.equipments.view.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/equipamentos' },
        { text: 'equipments', page: '/adm/equipamentos' },
        { text: 'equipment', page: null }
    ]

    const navigate = useNavigate();
    let { id } = useParams();
    const mapContainerRef = useRef(null);
    
    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const ProcessField = useRef();
    const CaseField = useRef();
    const MacField = useRef();
    const NameField = useRef();
    const ResolutionField = useRef();
    const EquipamentTypeField = useRef();
    const ETAField = useRef();
    const StateField = useRef();
    const CityField = useRef();
    const LatField = useRef();
    const LongField = useRef();
    const IcontypeField = useRef();
    const timeOutComunicationField = useRef();
    
    // const pocoConfig = useRef();
    
    const alocacaoValue = useRef();
    const ProcessValue = useRef();
    const CaseValue = useRef();
    const MacValue = useRef();
    const NameValue = useRef();
    const ResolutionValue = useRef();
    const EquipamentTypeValue = useRef();
    const ETAValue = useRef();
    const CityValue = useRef();
    const LatValue = useRef();
    const LongValue = useRef();
    const UpdateValue = useRef();
    const is_active = useRef();
    const icontypeValue = useRef();
    const timeOutComunicationValue = useRef();
    
    const Services = useRef(new EquipamentServices());
    
    const [equipamentType, setEquipamentType] = useState(false);
    const [selectedOption, setSelectedOption] = useState('location');
    const [loading, setLoading] = useState(true);
    const [equipamento, setEquipamento] = useState();
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [activeModal, setActiveModal] = useState("");
    const [equipmentsTypes, setEquipmentsTypes] = useState([]);
    
    const Allareas = useRef([]);
    const [areas, setAreas] = useState([]);
    const areaName = useRef();

    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);

    const IconTypes = [
        {
            id: "1f4d0674-1e7a-48c5-925f-87e2d99bcda6",
            name: 'Poço'
        },
        {
            id: "1f4d0674-1e7a-48c5-925f-87e2d99bcda5",
            name: 'Analisador'
        },
        {
            id: 'e2a17428-badd-4b2a-ace9-7f428f78cc1f',
            name: 'ETA',
        },
        {
            id: '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1',
            name: 'Sensor de vazão',
        },
        {
            id: '8831aa23-aa96-468f-bd48-10463cdaea6b',
            name: 'Reservatório'
        },
        {
            id: 'de4a6821-eb4c-492b-96c1-7ab704f053f6',
            name: 'Sensor de pressão',
        },
        {
            id: 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6',
            name: 'Sensor de nível'
        },
        {
            id: '52e63208-66ed-4a57-b41f-6f93b1b12f76',
            name: 'LORA'
        },
        {
            id: 'c71db0ce-7496-459d-9cb5-e24e8f5eba5b',
            name: 'Bio Dust'
        },
        {
            id: '32e9ece4-dc87-4ec5-b565-82fcab16511a',
            name: 'Bio Response'
        },
        {
            id: 'cfc1f45f-4599-48a1-8685-5c589c96909d',
            name: 'Bio MPF'
        }
    ];


    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());


    useEffect(() => {
        // Busca alocações do usuário
        const getLocations = async() => {
            try {
                let AllLocations = await Services.current.getLocations();

                let Types = Object.keys(AllLocations).map(type => {
                    return{
                        id: type,
                        name: type
                    }
                })
                store.dispatch(changeLoationtypes(Types));
            } catch (error) {
                
            }
        }

        const getStates = async() => {
            try {
                let States = await Services.current.getStates();
                setStates(States);
            } catch (error) {
                
            }
        }

        const getAreas = async(id) => {
            try {
                await Services.current.getAreasAndLines(id);
                const totalareas = await Services.current.getAllAreas();
                if(totalareas){
                    Allareas.current = totalareas;
                    setAreas(totalareas);
                }
            } catch (error) {
                console.log(error)
            }
        }
        
        // Busca dados do equipamento
        const getEquipament = async() => {
            setLoading(true)
            let currentequipament = await Services.current.getEquipament(id);
            if(currentequipament){
                getLocations();
                Services.current.startMap(mapContainerRef.current, currentequipament.coordinates.latitude, currentequipament.coordinates.longitude, 
                    currentequipament.id, currentequipament.name, currentequipament.type.id || currentequipament.id_icon_type);

                try {
                    NameField.current.getInputDOMNode().value = currentequipament.name
    
                    EquipamentTypeField.current.value = currentequipament.type.id
                } catch (error) {
                    
                }

                setEquipamentType(currentequipament.type.id)
                await getStates();
                await ChangeCities(currentequipament?.city?.state?.code_uf)
                getAreas(id);

                try {
                    StateField.current.value = currentequipament?.city?.state?.code_uf;
        
                    setTimeout(() => {
                        CityField.current.value = currentequipament?.city?.code_ibge;
                    }, 10);  
                } catch (error) {
                    
                }
    
                try {
                    Services.current.ChangeLocationType(currentequipament.allocation.type.name)
                    alocacao_typeField.current.value = currentequipament.allocation.type.name;
    
                    setTimeout(() => {
                        alocacaoField.current.value = currentequipament.allocation.id;
                    }, 10);
                } catch (error) {
                    
                }

                setEquipamento(currentequipament)
                UpdateValue.current = currentequipament.autoUpdate
                is_active.current = currentequipament.is_active;
                setLoading(false)
            }
        }

        const getEquipamentsTypes = async() => {
            try {
                let Types = await Services.current.getEquipamentsTypes();
                setEquipmentsTypes(Types);
            } catch (error) {
                console.log(error);
            }
        }

        try {
            getEquipamentsTypes();
            getEquipament();
        
        } catch (error) {
            console.log(error)            
        }
    }, [id]);

    // method-spoofing
    // Salva as edições do usuário
    const Save = async() => {
        if(isValidField(NameValue.current) && isValidField(EquipamentTypeValue.current) &&
        isValidField(alocacaoValue.current) && isValidField(CityValue.current) ){
            let form = new FormData();
            
            if(NameValue.current){form.append('name', NameValue.current)}
            if(EquipamentTypeValue.current){form.append('id_type', EquipamentTypeValue.current)}
            if(alocacaoValue.current){form.append('id_allocation', alocacaoValue.current)}
            if(CityValue.current){form.append('city_code', CityValue.current)}
            if(LatValue.current){form.append('latitude', LatValue.current)}
            if(LongValue.current){form.append('longitude', LongValue.current)}
            if(icontypeValue.current){form.append('id_icon_type', icontypeValue.current)}
            if(timeOutComunicationValue.current){form.append('communication_timeout_minutes', timeOutComunicationValue.current)}
            if(equipamentType === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5'){
                // Número de serie do processador (Poço)
                form.append('processor_id', ProcessValue.current)
                if(CaseValue.current){
                    form.append('maintenance_equipment_name', CaseValue.current)
                }else if(CaseValue.current === ''){
                    form.append('maintenance_equipment_name', '')
                }
            }else if(equipamentType === '0a22e8ed-42c1-496c-8d0a-82a4e05371c1'){
                // Módulo
                if(ETAValue.current){form.append('eta', ETAValue.current)}
            }else if(equipamentType === 'd0effc9e-4b90-4212-b800-4fb17cd5f67a' || equipamentType === 'de4a6821-eb4c-492b-96c1-7ab704f053f6' ||
                equipamentType === '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1' || equipamentType === 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6'){
                // Mac Address do equipamento (NBIOT)
                form.append('mac_address', MacValue.current)

                if(ResolutionValue.current){form.append('resolution', ResolutionValue.current)}
            }else if(equipamentType === '52e63208-66ed-4a57-b41f-6f93b1b12f76'){
                // LORA
                form.append('processor_id', ProcessValue.current)
            }
            form.append('autoUpdate', UpdateValue.current === true ? '1' : '0');
            form.append('is_active', is_active.current === true ? '1' : '0');
            
            form.append('_method', 'PATCH');
            Services.current.editEquipament(id, form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const ChangeCities = async(state) => {
        try {
            let Cities = await Services.current.getCities(state);
            setCities(Cities);
        } catch (error) {
            
        }
    }

    const saveLocations = async() => {
        const response = await Services.current.saveLocations(id, areaName.current ? areaName.current : equipamento?.name);
        setEquipamento(response)
    }

    return (
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <TitleContainer>
                    <Title>{equipamento?.name}</Title>
                </TitleContainer>
                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    value={equipamento?.name}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setEquipamento({...equipamento, 'name': text})
                                        NameValue.current = text
                                    }}> 
                                </Input>

                                <Label text={t("inputs.equipment-type.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'equipament'}
                                    id={'equipament'}
                                    placeholder={t("inputs.equipment-type.placeholder")}
                                    invalidMessage={t("inputs.equipment-type.invalid-message")}
                                    disabled={true}
                                    options={equipmentsTypes}
                                    innerRef={EquipamentTypeField}
                                    value={equipamento?.type?.id}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamento({...equipamento, 'type': {id: value}})
                                        setEquipamentType(value)
                                        EquipamentTypeValue.current = value
                                    }}>
                                </InputSelect>

                                {(equipamentType === '1f4d0674-1e7a-48c5-925f-87e2d99bcda5' || equipamentType === '52e63208-66ed-4a57-b41f-6f93b1b12f76') &&
                                    <>
                                        <Label text={t("inputs.processor.label")} aling="flex-start"/>
                                        <Input 
                                            aling="flex-start"
                                            id='processador' 
                                            name='processador' 
                                            type="text" 
                                            placeholder={t("inputs.processor.placeholder")}
                                            innerRef={ProcessField}
                                            value={equipamento?.processor_id}
                                            invalidMessage={t("inputs.processor.invalid-message")}
                                            validationFunction={(text) => isValidField(text)}
                                            onchange={(text) => ProcessValue.current = text}> 
                                        </Input>

                                        <Label text={t("inputs.case.label")} aling="flex-start"/>
                                        <Input 
                                            aling="flex-start"
                                            id='case' 
                                            name='case' 
                                            type="text" 
                                            placeholder={t("inputs.case.placeholder")}
                                            innerRef={CaseField}
                                            value={equipamento?.maintenance_equipment_name}
                                            invalidMessage={t("inputs.case.invalid-message")}
                                            validationFunction={(text) => isValidField(text)}
                                            onchange={(text) => CaseValue.current = text}> 
                                        </Input>
                                    </>
                                }


                                {(equipamentType === 'd0effc9e-4b90-4212-b800-4fb17cd5f67a' || equipamentType === 'de4a6821-eb4c-492b-96c1-7ab704f053f6' ||
                                    equipamentType === '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1' || equipamentType === 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6') &&
                                    <>
                                        <Label text={t("inputs.mac-address.label")} aling="flex-start"/>
                                        <Input 
                                            aling="flex-start"
                                            id='macAddress' 
                                            name='macAddress' 
                                            type="text" 
                                            placeholder="Mac Address"
                                            innerRef={MacField}
                                            value={equipamento?.mac_address}
                                            invalidMessage="Mac Address inválido"
                                            validationFunction={(text) => isValidField(text)}
                                            onchange={(text) => MacValue.current = text}> 
                                        </Input>
                                    </>
                                }

                                <Label text={t("inputs.timeout-comunication.label")} aling="flex-start"/>
                                <Input
                                    aling="flex-start"
                                    id='timeoutComunication'
                                    name='timeoutComunication'
                                    type="number"
                                    placeholder={t("inputs.timeout-comunication.placeholder")}
                                    innerRef={timeOutComunicationField}
                                    value={equipamento?.communication_timeout_minutes}
                                    invalidMessage={t("inputs.timeout-comunication.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setEquipamento({...equipamento, 'communication_timeout_minutes': text})
                                        timeOutComunicationValue.current = text
                                    }}>
                                </Input>
                            </ContainerColumn>
                            
                            <ContainerColumn>
                                <Label text={t("inputs.state.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'state'}
                                    id={'state'}
                                    placeholder={t("inputs.state.placeholder")}
                                    invalidMessage={t("inputs.state.invalid-message")}
                                    options={states}
                                    innerRef={StateField}
                                    value={equipamento?.city?.state?.code_uf}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamento({...equipamento, 'city': {...equipamento.city, 'state': {...equipamento.city.state, 'code_uf': value}}})
                                        ChangeCities(value)}}>
                                </InputSelect>

                                <Label text={t("inputs.city.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'city'}
                                    id={'city'}
                                    placeholder={t("inputs.city.placeholder")}
                                    invalidMessage={t("inputs.city.invalid-message")}
                                    options={cities}
                                    innerRef={CityField}
                                    value={equipamento?.city?.code_ibge}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamento({...equipamento, 'city': {...equipamento.city, 'code_ibge': value}})
                                        CityValue.current = value}}>
                                </InputSelect>

                                <Label text={t("inputs.latitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='latitude' 
                                    name='latitude' 
                                    type="text" 
                                    placeholder={t("inputs.latitude.placeholder")}
                                    value={equipamento?.coordinates?.latitude}
                                    innerRef={LatField}
                                    invalidMessage={t("inputs.latitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setEquipamento({...equipamento, 'coordinates': {...equipamento.coordinates, 'latitude': text}})
                                        LatValue.current = text}}> 
                                </Input>

                                <Label text={t("inputs.longitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.longitude.placeholder")}
                                    value={equipamento?.coordinates?.longitude}
                                    innerRef={LongField}
                                    invalidMessage={t("inputs.longitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setEquipamento({...equipamento, 'coordinates': {...equipamento.coordinates, 'longitude': text}})
                                        LongValue.current = text}}> 
                                </Input>

                                {equipamentType === '0a22e8ed-42c1-496c-8d0a-82a4e05371c1' &&
                                    <>
                                        <Label text={t("inputs.eta.label")} aling="flex-start"/>
                                        <InputSelect
                                            name={'eta'}
                                            id={'eta'}
                                            placeholder={t("inputs.eta.placeholder")}
                                            invalidMessage={t("inputs.eta.invalid-message")}
                                            options={[]}
                                            innerRef={ETAField}
                                            value={equipamento?.eta}
                                            validationFunction={(value) => isValidField(value)}
                                            onchange={(value) => {
                                                setEquipamento({...equipamento, 'eta': value})
                                                ETAValue.current = value}}>
                                        </InputSelect>
                                    </>
                                }
                                {/* {user?.user?.can?.includes('equipment.edit') ?
                                    <Button onClick={()=>store.dispatch(changeModal('config'))} width={'fit-content'} color={'green'} icon={''} text={'Configurar'}></Button>
                                :<></>} */}
                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao_type'}
                                    name={'alocacao_type'}
                                    id={'alocacao_type'}
                                    placeholder={t("inputs.allocation-type.placeholder")}
                                    invalidMessage={t("inputs.allocation-type.invalid-message")}
                                    options={LocationTypes}
                                    innerRef={alocacao_typeField}
                                    value={equipamento?.allocation?.type?.name}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamento({...equipamento, 'allocation': {...equipamento.allocation, 'type': {...equipamento.allocation.type, 'name': value}}})
                                        Services.current.ChangeLocationType(value, alocacaoField.current)
                                        }}>
                                </InputSelect>

                                <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao'}
                                    name={'alocacao'}
                                    id={'alocacao'}
                                    placeholder={t("inputs.allocation-local.placeholder")}
                                    invalidMessage={t("inputs.allocation-local.invalid-message")}
                                    options={Locations}
                                    innerRef={alocacaoField}
                                    value={equipamento?.allocation?.id}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamento({...equipamento,  'allocation': {...equipamento.allocation, 'id': value}})
                                        alocacaoValue.current = value}}>
                                </InputSelect>

                                {(equipamentType === 'd0effc9e-4b90-4212-b800-4fb17cd5f67a' || equipamentType === 'de4a6821-eb4c-492b-96c1-7ab704f053f6') &&
                                <>
                                    <Label text={t("inputs.resolution.label")} aling="flex-start"/>
                                    <Input 
                                        aling="flex-start"
                                        id='resolution' 
                                        name='resolution' 
                                        type="number" 
                                        placeholder={t("inputs.resolution.placeholder")}
                                        innerRef={ResolutionField}
                                        invalidMessage={t("inputs.resolution.invalid-message")}
                                        value={equipamento?.resolution}
                                        validationFunction={(text) => isValidField(text)}
                                        onchange={(text) => {
                                            setEquipamento({...equipamento, 'resolution': text})
                                            ResolutionValue.current = text}}> 
                                    </Input>
                                </>}

                                <Label text={t("inputs.icon-type.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'icon_Type'}
                                    name={'icon_Type'}
                                    id={'icon_Type'}
                                    placeholder={t("inputs.icon-type.placeholder")}
                                    invalidMessage={t("inputs.icon-type.invalid-message")}
                                    options={IconTypes}
                                    innerRef={IcontypeField}
                                    value={equipamento?.id_icon_type}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setEquipamento({...equipamento,  'id_icon_type': value})
                                        icontypeValue.current = value}}>
                                </InputSelect>

                                <Label text={t("administrative.sub-items.equipments.view.additional-config")} aling="flex-start"/>
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <InputCheckbox text={t("checkbox.auto-update")} onChange={(value)=> {
                                            UpdateValue.current = value;
                                            setEquipamento({...equipamento, 'autoUpdate': value });
                                        }} checked={equipamento?.autoUpdate}/>

                                    <InputCheckbox text={t("checkbox.is-active")} onChange={(value)=> {
                                        is_active.current = value;
                                        setEquipamento({...equipamento, 'is_active': value });
                                    }} checked={equipamento?.is_active}/>
                                </div>

                                <RowContainer>
                                    <Button text={t("buttons.setup-map")} width={'fit-content'} onClick={() => {
                                        store.dispatch(changeModal('equipmentLocation'));
                                        Services.current.resizeMap();    
                                    }}/>

                                    {user.user.can.includes('administrador.adm') ?
                                    <Button text={t("buttons.history-data")} width={'fit-content'} 
                                        onClick={() => {store.dispatch(changeModal('history-data'))}}/>
                                    :<></>}
                                    
                                    {user?.user?.can?.includes('card.autoupdate') && 
                                    (user?.user?.id === "182fbfd6-86ab-4fa2-b588-c12825c64361" || user?.user?.id === "2123e214-6dde-4dc0-9911-41b17ff4b067") &&
                                        <Button text={t("buttons.refresh-data")} icon={<ImageIcon src={Atualizar}/>} onClick={() => setActiveModal('update-jsons')}/>
                                    }
                                </RowContainer>
                            </ContainerColumn>
                        </ContainerRow>

                        <ButtonsContainer>
                            {user?.user?.can?.includes('equipment.edit') ?
                                <>
                                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                                </>
                            :<></>}
                            {user?.user?.can?.includes('equipment.delete') ?
                                <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} 
                                    onClick={() => setActiveModal('delete-equipment')} 
                                icon={<ImageIcon src={Excluir}/>}/>
                            :<></>}
                        </ButtonsContainer>
                    </>
                }
            </Container>

            <Modal name={'equipmentLocation'} width={'70%'} height={'90%'}>

                <MapOptions>
                    <Button text={t("buttons.area")} width={'fit-content'}  color={selectedOption === 'area' ? 'gradienteGreen' : 'green'} onClick={() => {
                        setSelectedOption('area')
                        Services.current.setClickType('area');
                    }}/>

                    <Button text={t("buttons.line")} width={'fit-content'} color={selectedOption === 'line' ? 'gradienteGreen' : 'green'} onClick={() => {
                        setSelectedOption('line')
                        Services.current.setClickType('line');
                    }}/>

                    <Button text={t("buttons.equipment-location")} width={'fit-content'} color={selectedOption === 'location' ? 'gradienteGreen' : 'green'} onClick={() => {
                        setSelectedOption('location')
                        Services.current.setClickType('location');
                    }}/>
                </MapOptions>

                <div
                    style={{ 
                    position: 'relative',
                    height: '100%',
                    width: '100%'
                    }}>

                    <ContainerMap ref={mapContainerRef} />

                    <MapButtons $left={'5px'}>
                        <Button text={t("buttons.redo")} icon={<BtnIcon src={Refazer}/>} width={'fit-content'} onClick={() => {
                            Services.current.redo();
                        }}/>

                        <Button text={t("buttons.undo")} icon={<BtnIcon src={Desfazer}/>} width={'fit-content'} onClick={() => {
                            Services.current.undo();
                        }}/>
                    </MapButtons>

                    <MapButtons $right={'5px'}>
                        <Button text={t("buttons.cancel")} width={'150px'} onClick={() => store.dispatch(changeModal(''))}/>

                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => saveLocations()}/>
                    </MapButtons>

                    <AreasOptions $right={'5px'} $selectedOption={selectedOption === 'line'}>
                        <Button text={t("buttons.cleanLines")} color={'white-red'} width={'fit-content'} onClick={() => {
                            Services.current.cleanLines();
                        }}/>
                    </AreasOptions>

                    <AreasOptions $left={'5px'} $selectedOption={selectedOption === 'area'}>
                        <Label text={t("inputs.name.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='name' 
                            name='name' 
                            type="text" 
                            placeholder={t("inputs.name.placeholder")}
                            invalidMessage={t("inputs.name.invalid-message")}
                            validationFunction={(text) => isValidField(text)}
                            onchange={(text) => {
                                areaName.current = text;
                            }}> 
                        </Input>
                    </AreasOptions>

                    <AreasOptions $right={'5px'} $bottom={'95px'} $selectedOption={selectedOption === 'area'}>
                        <AreasTitle>{t("modal.equipment-location.areas")}</AreasTitle>
                        <AreaSrcoll>
                            {
                                areas.map((area, index) => (
                                    <InputCheckbox key={index} text={area.name} onChange={async (value)=> {
                                        if(value){
                                            const response = await Services.current.addArea(id, area.id);
                                            return response
                                        }else{
                                            const response = await Services.current.removeArea(id, area.id);
                                            return response
                                        }
                                    }} checked={area.checked}/>
                                ))
                            }
                        </AreaSrcoll>
                    </AreasOptions>
                </div>
            </Modal>

            <Modal title={t("modal.history-data.title")} id={"history-data-modal"} name={'history-data'} width={'780px'} height={'76%'}>                
                <CalendarContainer>
                    <Calendar title={t("calendar.title.initial-date")}  selectedDate={initialDate} onDateChange={setInitialDate} />
                    <Calendar title={t("calendar.title.final-date")} selectedDate={finalDate} onDateChange={setFinalDate}/>
                </CalendarContainer>
                <RowContainer>
                    <Button text={t("buttons.cancel")} width={'150px'} onClick={() => store.dispatch(changeModal(''))}/>
                    <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal('confirm-delete-history'))}/>
                    <Button text={t("buttons.restore")} width={'150px'} color={'white-green'} onClick={() => {
                        Services.current.EquipmentHistory(id, initialDate.toISOString().slice(0, 10)+'T00:00', finalDate.toISOString().slice(0, 10)+'T23:59:59', "restore");
                    }}/>
                </RowContainer>
            </Modal>

            <Modal title={t("modal.delete-history.title")} name={'confirm-delete-history'} width={'50%'} height={'33%'}>                   
                <ModalText>
                    {t("modal.delete-history.success",  { equipment: equipamento?.name})}  <br />
                    {t("modal.delete-history.date", { initialDate, finalDate})}  <br />
                </ModalText>
                <RowContainer>
                    <Button text={t("buttons.cancel")} width={'150px'}  onClick={() => store.dispatch(changeModal('history-data'))}/>
                    <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={() => {
                        Services.current.EquipmentHistory(id, initialDate.toISOString().slice(0, 10)+'T00:00', finalDate.toISOString().slice(0, 10)+'T23:59:59', "delete");
                        store.dispatch(changeModal(''));
                    }} />
                </RowContainer>
            </Modal>

            <CustonModal Title={t("modal.delete-equipment.title")} Active={activeModal === 'delete-equipment'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.deleteEquipament(id, navigate)}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>

            <CustonModal Title={t("modal.update-jsons.title")} Active={activeModal === 'update-jsons'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.refreshEquipment(id)}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>
        </>
    );
}

export default ViewEquipaments;